'use strict';

var React = require('react');

var SvgGlobeAsiaFilledIcon = function SvgGlobeAsiaFilledIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3 10a7 7 0 1 1 14 0 7 7 0 0 1-14 0Zm7-5.5a5.502 5.502 0 0 0-5.424 4.584l.276.183a.75.75 0 0 0 1.016-.174l.262-.35a.75.75 0 0 1 1.334.303l.103.515a.857.857 0 0 0 1.554.307l.374-.561a1.25 1.25 0 0 1 1.04-.557h.184a.75.75 0 0 0 .728-.568l.121-.485c.068-.27.22-.5.425-.667l.007-.03h.03c.212-.158.473-.25.75-.25h.22a.75.75 0 0 0 .75-.75v-.023a5.48 5.48 0 0 0-3.75-1.477Zm4 5.18v-.254a.743.743 0 0 1 .152-.34l.938-1.173c.257.625.402 1.309.41 2.025l-.304.228a.757.757 0 0 1-1.196-.487Zm-6.186 5.369c.67.29 1.41.451 2.186.451 1.29 0 2.475-.444 3.412-1.186a2.523 2.523 0 0 0-1.963-.939h-.52c-.467 0-.906.22-1.186.592-.165.22-.384.395-.635.506l-1.294.575Z"
  }));
};
SvgGlobeAsiaFilledIcon.displayName = "GlobeAsiaFilledIcon";

exports.SvgGlobeAsiaFilledIcon = SvgGlobeAsiaFilledIcon;
